export const colors = {
  black: '#000',
  background: '#F2EEE6',
  olive: '#4B4C36',
  dune: '#D2CDBF',
  khaki: '#857D66',
  umber: '#4D402C',
  red: '#ff0000',
}
